import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register plugins once, module-level, so every component can import gsap and
// ScrollTrigger without re-registering.
gsap.registerPlugin(ScrollTrigger);

export { gsap, ScrollTrigger };
